// GENERATED FILE — do not edit. Written by scripts/build-geo.mjs.
//
// Maps each served geometry file to a hash of its contents, appended to the
// URL as ?v=<hash>. Re-run `npm run geo:build` after changing anything in
// geodata/ and commit this alongside the regenerated files.

const GEO_ASSET_HASHES = {
  "/ukmaps/2024_constituency.topo.json": "3a537d9c",
  "/ukmaps/2024_ward_withPCON.topo.json": "ea7908ae",
  "/ukmaps/2023_local_authority.topo.json": "ea34f823",
  "/ukmaps/2024_constituency.json": "eb241a3a",
  "/ukmaps/2024_ward_withPCON.json": "7b7dfb81"
};

/** Public URL for a generated geometry file, with its cache-busting stamp. */
export const geoAssetUrl = (file) => {
  const base = (process.env.PUBLIC_URL || "") + file;
  const hash = GEO_ASSET_HASHES[file];
  return hash ? base + '?v=' + hash : base;
};
